const _ = require('lib/underscore')
const Marionette = require('lib/marionette')
const Element = require('../model/element.base')


const InputButtonFieldView = Marionette.View.extend({

    displayName: 'InputButtonFieldView',

    tagName: 'span',

    template: _.template('<input><button></button>'),

    ui: {
        input: 'input',
        button: 'button',
    },

     
    constructor: function constructor() {
        Marionette.View.apply(this, arguments)

        // validate model
        if (! (this.model instanceof Element)) throw new Error('InputView requires an Element model.')

        // these steps allow the view to consume an existing dom element
        this.listenTo(this, 'render', this.setAttributes)
        const className = this.model.get('className')
        if (className) this.$el.addClass(className)
    },

    onRender() {
        // inline require to allow circular dependency between Element & ElementList
        const InputViewTypes = require('./input_view_types')

        const input = this.model.get('input')
        const InputView = InputViewTypes[input.get('type')]

        this.input_view = new InputView({
            el: this.ui.input,
            model: input,
        })
        this.input_view.render()
        this.on('before:destroy', () => {
            this.input_view.destroy()
        })

        const button = this.model.get('button')
        const ButtonView = InputViewTypes[button.get('type')]
        this.button_view = new ButtonView({
            el: this.ui.button,
            model: button,
        })
        this.button_view.render()
        this.on('before:destroy', () => {
            this.button_view.destroy()
        })

    },

})

module.exports = InputButtonFieldView
